import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  Label,
  Cell
} from "recharts";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

class MaxthroughputSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  generateTicks = linkspeed => {
    let diff = linkspeed / 5;
    let tickArray = [];
    for (var i = 0; i <= 5; i++) {
      tickArray.push((diff * i).toFixed(1));
    }
    return tickArray;
  };

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    let graphData = [];
    results.data.subtests[subtest] &&
      results.data.subtests[subtest].percentageutilizationgraphdetails &&
      results.data.subtests[subtest].percentageutilizationgraphdetails.forEach(
        function(item) {
          graphData.push({
            name: item.framesize,
            value: item.framesize,
            linkspeed: results.data.subtests[subtest].linkspeed,
            filledgradient:
              (item.filledgradient / 100) *
              results.data.subtests[subtest].linkspeed,
            emptygradient:
              results.data.subtests[subtest].linkspeed -
              (item.filledgradient / 100) *
                results.data.subtests[subtest].linkspeed,
            status: item.status
          });
        }
      );

    return (
      results.data.subtests[subtest] && (
        <Grid container spacing={0}>
          <Grid xs={12} className={classes.topGrid}>
            <BarChart
              width={250}
              height={220}
              data={graphData}
              layout="vertical"
              margin={{
                right: 10
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                type="number"
                dataKey="linkspeed"
                domain={[0, "dataMax"]}
                //interval={2}
                height={60}
                ticks={this.generateTicks(
                  results.data.subtests[subtest].linkspeed
                )}
              >
                <Label
                  //angle={270}
                  position="center"
                  style={{ textAnchor: "middle", fontSize: 10 }}
                  dy={5}
                >
                  {translate("uptime_linkspeed")}
                </Label>
              </XAxis>

              <YAxis type="category" dataKey="value">
                <Label
                  angle={270}
                  position="left"
                  style={{ textAnchor: "middle", fontSize: 10 }}
                  dx={15}
                >
                  {translate("uptime_frame_size")}
                </Label>
              </YAxis>
              {/* <Tooltip /> */}
              {/* <Legend /> */}
              <Bar
                dataKey="filledgradient"
                fill="#4caf50"
                barSize={25}
                stackId="a"
              >
                {graphData.map((entry, index) => (
                  <Cell
                    fill={entry.status === "PASSED" ? "#4caf50" : "#FF5252"}
                    stroke="#000000"
                    strokeWidth={0.3}
                  />
                ))}
              </Bar>
              <Bar
                dataKey="emptygradient"
                fill="#FFFFFF"
                barSize={25}
                stackId="a"
              >
                {graphData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    stroke="#000000"
                    strokeWidth={0.3}
                  />
                ))}
              </Bar>
            </BarChart>
          </Grid>
        </Grid>
      )
    );
  }
}

export default withStyles(styles)(MaxthroughputSubtest);
